import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import './assets/fonts/Arimo/Arimo-Regular.ttf'; 
import './assets/fonts/EBGaramond/EBGaramond12-Regular.otf'; 

ReactDOM.render(
  <App />,
  document.getElementById('root')
);

reportWebVitals();